import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { getSsoUrl, getAgentLoginUrl } from '../utils/routes';
import { SSO_RETURN_URL_KEY } from '../utils/config';
import { getAgentLoginEnabled, getUserIsLoggedIn } from '../utils/globals';
/**
 * # useLogin
 *
 * A hook to allow manual logging in of the user.
 *
 * If `agentLogin` is passed in, then the user will be logged in with Elevio.
 *
 * ```typescript
 * const SomeLoginComponent = function ({ agentLogin }: { agentLogin: boolean }) {
 *   const { isAgentLoginEnabled, isLoggedIn, login, url } = useLogin({
 *     agentLogin,
 *   });
 *
 *   console.log({ isAgentLoginEnabled }); // boolean
 *   console.log({ isLoggedIn }); // boolean
 *   console.log({ url }); // string
 *
 *   const onClick = () => {
 *     login();
 *   };
 *
 *   return <button onClick={onClick}>Login</button>;
 * };
 * ```
 */
export function useLogin(opts = {}) {
    const { agentLogin } = opts;
    const isAgentLoginEnabled = getAgentLoginEnabled();
    const url = agentLogin && isAgentLoginEnabled ? getAgentLoginUrl() : getSsoUrl();
    const login = useCallback(() => {
        Cookies.set(SSO_RETURN_URL_KEY, window.location.href);
        window.location.href = url;
    }, [url]);
    return {
        login,
        url,
        isAgentLoginEnabled,
        isLoggedIn: getUserIsLoggedIn(),
    };
}
//# sourceMappingURL=useLogin.js.map